import React from "react";

const RadioButton = ({
  name,
  id,
  label,
  onChange,
  onBlur,
  value,
  ...props
}) => {
  return (
    <div className="radio mt-4">
      <input
        name={name}
        id={id}
        type="radio"
        value={id}
        checked={id === value}
        onChange={onChange}
        onBlur={onBlur}
        {...props}
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

export default RadioButton;
